"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _MinimumUsage["default"];
  }
});
var _MinimumUsage = _interopRequireDefault(require("./MinimumUsage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }